"use client";

import { useTranslations } from "next-intl";
import React, { useMemo } from "react";

import NavLink from "@/components/navigation/NavLink";
import { useAuth } from "@/contexts/AuthContext";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { usePathname } from "@/i18n/routing";
import { NavigationLink } from "@/utils/constants";
import { filterNavigationLinks } from "@/utils/navigation";

interface DesktopNavLinksWrapperProps {
  navigationLinks: NavigationLink[];
}

const DesktopNavLinksWrapper: React.FC<DesktopNavLinksWrapperProps> = ({ navigationLinks }) => {
  const isLargeScreen = useMediaQuery("(min-width: 1280px)");
  const pathname = usePathname();
  const t = useTranslations("Navigation");
  const { agentAccess } = useAuth();

  const visibleLinks = useMemo(
    () =>
      filterNavigationLinks(navigationLinks, {
        isSalesAgent: agentAccess.isSalesAgent,
        variant: "desktop",
      }),
    [agentAccess.isSalesAgent, navigationLinks],
  );

  if (!isLargeScreen) {
    return null;
  }

  return (
    <>
      {/* Desktop Menu */}
      <div className="hidden xl:flex">
        {visibleLinks
          .filter((link) => link.navBar)
          .map((link, idx) => (
            <NavLink
              key={`desk-${link.href}-${idx}`}
              variant="navbar"
              href={link.href}
              isActive={pathname.startsWith(link.href)}
            >
              {t(link.name)}
            </NavLink>
          ))}
      </div>
    </>
  );
};

export default DesktopNavLinksWrapper;
